<script setup lang="ts">
    import { useViewControlsClusterViewModel } from '@/views/3d-planner/view-controls/useViewControlsClusterViewModel';
    import CtSliderStrip from './CtSliderStrip.vue';
    import ShowOutlinesToggle from './ShowOutlinesToggle.vue';
    import { catstackPlaneIds } from '@/domain/anatomy/catstackPlane';

    const vm = useViewControlsClusterViewModel();
</script>

<template>
    <div v-if="vm.rowOpen" class="ct-slider-row">
        <div class="slider-container">
            <ct-slider-strip
                v-for="planeId in catstackPlaneIds"
                :key="planeId"
                :plane-id="planeId"
            />
            <show-outlines-toggle class="implant-outlines-toggle" />
        </div>
    </div>
</template>

<style scoped lang="scss">
    .ct-slider-row {
        background: rgb(var(--v-theme-dark-background));
        padding: 4px 14px;
        height: 62px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        // Top-right of the cluster when this row is visible; the cluster has
        // no overflow:hidden so thumb-labels can escape upward.
        border-radius: 0 13px 0 0;
    }
    .slider-container {
        display: flex;
        align-items: stretch;
        justify-content: space-between;
        gap: 72px; // roughly the width of a Hide button
        border-radius: 12px;
        width: 100%;
        max-width: 1400px; // stop the sliders growing past a comfortable size
        margin-inline: auto; // centre the container when the bar is wider
        height: 45px;
        position: relative;

        // Show Implant Outlines toggle sits at the right of the same grouping
        // as the strips. Centred vertically rather than stretched, and given
        // its natural width so the strips share the remaining space evenly.
        // When `showOutlinesVisible` is false the toggle renders nothing, so
        // the strips automatically reclaim the space.
        .implant-outlines-toggle {
            flex: 0 0 auto;
            align-self: center;
        }

        // Separator drawn at the bottom edge of the ct-slider-row, spanning the
        // slider-container's exact width (including max-width / margin-inline behaviour).
        // The ::after is on the container so it grows/shrinks with it rather than
        // being pinned to fixed left/right insets on the full-width row.
        &::after {
            content: '';
            position: absolute;
            bottom: -4px; // offset past the 4px padding-bottom of .ct-slider-row
            left: 0;
            right: 0;
            height: 1px;
            background: var(--v-on-dark-divider);
        }
    }
</style>
